var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 29,
    viewBox: "0 0 14 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32502 28.0025C2.62381 28.0035 2.91903 27.9376 3.18899 27.8095C3.45895 27.6815 3.69679 27.4945 3.88502 27.2625L13.545 15.2625C13.8392 14.9046 14 14.4558 14 13.9925C14 13.5293 13.8392 13.0804 13.545 12.7225L3.54502 0.722505C3.20555 0.314071 2.71772 0.0572224 2.18887 0.008463C1.66002 -0.0402965 1.13346 0.123027 0.725022 0.462504C0.316589 0.801982 0.059741 1.2898 0.0109816 1.81866C-0.0377779 2.34751 0.125546 2.87407 0.465022 3.2825L9.40502 14.0025L0.765023 24.7225C0.520457 25.0161 0.365103 25.3736 0.317344 25.7527C0.269585 26.1317 0.331419 26.5166 0.49553 26.8617C0.659642 27.2067 0.919162 27.4975 1.24338 27.6997C1.5676 27.9019 1.94296 28.007 2.32502 28.0025Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret_right.dba7fa3c6dbd0fa0d14009bf27f51afd.svg";
export { ForwardRef as ReactComponent };